import { Routes } from '@angular/router';
import { HasRoleGuard } from '../guards/has-role.guard';
import { LP_PORTAL_ROLES } from '../helpers';
import { LossPreventionAdminCreateReviewComponent } from '../secure/tabs/loss-prevention/admin/create-review/create-review.component';
import { LossPreventionAdminDashboardComponent } from '../secure/tabs/loss-prevention/admin/dashboard/dashboard.component';
import { InspectAssignmentComponent } from '../secure/tabs/loss-prevention/admin/inspect-assignment/inspect-assignment.component';
import { LossPreventionAdminInvestigationQueueComponent } from '../secure/tabs/loss-prevention/admin/investigation-queue/investigation-queue.component';
import { LossPreventionAdminLocationInstructionsComponent } from '../secure/tabs/loss-prevention/admin/location-instructions/location-instructions.component';
import { LossPreventionAdminManageQueueComponent } from '../secure/tabs/loss-prevention/admin/manage-queue/manage-queue.component';
import { LossPreventionAdminNavigationComponent } from '../secure/tabs/loss-prevention/admin/navigation/navigation.component';
import { LossPreventionAdminQueuedAssignmentsComponent } from '../secure/tabs/loss-prevention/admin/queued-assignments/queued-assignments.component';
import { LossPreventionAdminReviewPrioritiesComponent } from '../secure/tabs/loss-prevention/admin/review-priorities/review-priorities.component';
import { LossPreventionAdminSideloadReviewComponent } from '../secure/tabs/loss-prevention/admin/sideload-review/sideload-review.component';
import { AdminUploadTransactionsComponent } from '../secure/tabs/loss-prevention/admin/upload-transactions/upload-transactions.component';
import { InvestigationAssignmentComponent } from '../secure/tabs/loss-prevention/investigation-assignment/investigation-assignment.component';
import { LossPreventionHomeComponent } from '../secure/tabs/loss-prevention/loss-prevention-home/loss-prevention-home.component';
import { ReviewCheckAssignmentComponent } from '../secure/tabs/loss-prevention/review-check-assignment/review-check-assignment.component';
import { SelfServiceAssignmentComponent } from '../secure/tabs/loss-prevention/self-service-assignment/self-service-assignment.component';
import { ValidationAssignmentComponent } from '../secure/tabs/loss-prevention/validation-assignment/validation-assignment.component';
import { LoginRedirectGuard } from '../guards/login-redirect.guard';

export const lossPreventionRoutes: Routes = [
  {
    path: '',
    redirectTo: '/lp',
    pathMatch: 'full',
  },
  {
    path: 'lp',
    component: LossPreventionHomeComponent,
    canActivate: [LoginRedirectGuard],
  },
  {
    path: 'lp/review',
    component: ReviewCheckAssignmentComponent,
    data: { requiredRoles: ['admin', 'investigator'] },
    canActivate: [HasRoleGuard],
  },
  {
    path: 'lp/self-service',
    component: ReviewCheckAssignmentComponent,
    data: { requiredRoles: ['admin', 'self-service', 'self-service-investigator'] },
    canActivate: [HasRoleGuard],
  },
  {
    path: 'lp/validate',
    component: ReviewCheckAssignmentComponent,
    data: { requiredRoles: ['admin', 'validator'] },
    canActivate: [HasRoleGuard],
  },
  {
    path: 'lp/admin',
    component: LossPreventionAdminNavigationComponent,
    data: { requiredRoles: LP_PORTAL_ROLES },
    canActivate: [HasRoleGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        component: LossPreventionAdminDashboardComponent,
      },
      {
        path: 'priorities',
        component: LossPreventionAdminReviewPrioritiesComponent,
      },
      {
        path: 'inspect',
        component: InspectAssignmentComponent,
      },
      {
        path: 'inspect/:assignmentId',
        component: InspectAssignmentComponent,
      },
      {
        path: 'upload-transactions',
        component: AdminUploadTransactionsComponent,
      },
      {
        path: 'sideload-review',
        component: LossPreventionAdminSideloadReviewComponent,
      },
      {
        path: 'location-instructions',
        component: LossPreventionAdminLocationInstructionsComponent,
      },
      {
        path: 'investigation-queue',
        component: LossPreventionAdminInvestigationQueueComponent,
      },
      {
        path: 'queued-assignments',
        component: LossPreventionAdminQueuedAssignmentsComponent,
      },
      {
        path: 'manage-queue',
        component: LossPreventionAdminManageQueueComponent,
      },
      {
        path: 'create-review',
        component: LossPreventionAdminCreateReviewComponent,
      },
    ],
  },
  {
    path: 'lp/review/:assignmentId',
    component: InvestigationAssignmentComponent,
    data: { requiredRoles: ['admin', 'investigator'] },
    canActivate: [HasRoleGuard],
  },
  {
    path: 'lp/self-service/:assignmentId',
    component: SelfServiceAssignmentComponent,
    data: { requiredRoles: ['admin', 'self-service', 'self-service-investigator'] },
    canActivate: [HasRoleGuard],
  },
  {
    path: 'lp/validate/:assignmentId',
    component: ValidationAssignmentComponent,
    data: { requiredRoles: ['admin', 'validator'] },
    canActivate: [HasRoleGuard],
  },
];
